"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identity = exports.actionCreators = void 0;
/**
 * Action creator factors.
 *
 * Example:
 *
 * export const actions = actionCreators({
 *   somethingHappened: (payload: { name: string }) => payload
 * })
 */
const actionCreators = (payloadCreators, namespace) => {
    return Object.entries(payloadCreators).reduce((actionCreators, [type, createPayload]) => {
        // create new factory for action types
        const namespacedType = `${namespace}/${type}`;
        const createAction = (...args) => ({
            type: namespacedType,
            payload: createPayload && createPayload(...args),
        });
        // specify namespace ot avoid collisions
        createAction.type = namespacedType;
        actionCreators[type] = createAction;
        return actionCreators;
    }, {});
};
exports.actionCreators = actionCreators;
/**
 * Shorthand for (v: { name: string }) => v
 *
 * actionCreators({
 *   somethingHappened: identity as Identity<{name: string }>
 * })
 */
const identity = () => (value) => value;
exports.identity = identity;
//# sourceMappingURL=util.js.map